export const EDITABLE_BOOLEAN_FIELDS = ['handlesShowcase', 'isActive', 'isSynced', 'ignoreMinMax'];
